import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
export const PageHeaderTools = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: css(styles.pageHeaderTools, className) }, props), children));
};
PageHeaderTools.displayName = 'PageHeaderTools';
//# sourceMappingURL=PageHeaderTools.js.map